const emailUpdateConstant = {
  EMAIL_UPDATE_API_TYPES: {
    EMAIL_UPDATE: "EMAIL_UPDATE",
  },
};

export default emailUpdateConstant;
